'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _abp = require('abp');

var _abp2 = _interopRequireDefault(_abp);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('App');

var attributeName = 'data-min-max-setting';
var attributeSelector = '[' + attributeName + ']';
var keyupTimeoutHandle = 0;

function onChange(el) {
    if (keyupTimeoutHandle) {
        clearTimeout(keyupTimeoutHandle);
        keyupTimeoutHandle = 0;
    }
    var $wrapper = (0, _jquery2.default)(el).closest(attributeSelector);
    var $button = $wrapper.find(':button');
    if ($button.length === 0) {
        persistChange($wrapper); // save on change - when without button
    } else {
        // show save button if exist
        $button.toggleClass('active', true);
    }
}

function persistChange($wrapper) {
    var productId = $wrapper.attr(attributeName);
    var $min = $wrapper.find('[name="minAmount"]');
    var $max = $wrapper.find('[name="maxAmount"]');
    var minAmount = $min.val();
    var maxAmount = $max.val();
    if (minAmount != $min.attr('data-value') || maxAmount != $max.attr('data-value')) {
        _abp2.default.services.api.minMaxSetting.set({
            productId: productId, minAmount: minAmount, maxAmount: maxAmount
        }).done(function (result) {
            $min.attr('data-value', result.minAmount).val(minAmount);
            $max.attr('data-value', result.maxAmount).val(maxAmount);
            _notify2.default.success(Resx.App.MinMaxSettingSaved);
        });
    }
}

(0, _jquery2.default)(document).on('keyup', attributeSelector + ' input', function () {
    var _this = this;

    var $wrapper = (0, _jquery2.default)(this).closest(attributeSelector);
    if ($wrapper.find(':button').length > 0) {
        // button exists, show it
        onChange(this);
    } else {
        if (keyupTimeoutHandle) clearTimeout(keyupTimeoutHandle);
        keyupTimeoutHandle = setTimeout(function () {
            onChange(_this);
        }, 3000);
    }
});

(0, _jquery2.default)(document).on('change', attributeSelector + ' input', function () {
    onChange(this);
});

(0, _jquery2.default)(document).on('click', attributeSelector + ' button', function () {
    var $button = (0, _jquery2.default)(this);
    $button.toggleClass('active', false);
    persistChange($button.closest(attributeSelector));
});

//var moduleEnabled = true;
//
//
// $(document).on('click', attributeSelector + ' button', function (e) {
//     if (!moduleEnabled) return;
//     abp.services.api.minMaxSetting.set({
//         productId: getProductId(),
//         minAmount: min(),
//         maxAmount: max()
//     }).done(processResult).always(doAlways);
// });
//
// // on document ready
// $(function () {
//     const productId = getProductId();
//     moduleEnabled = !!productId;
//     if (!moduleEnabled) return;
//     abp.log.debug('min-max load for ' + productId);
//     abp.services.api.minMaxSetting.get(productId).done(processResult).always(doAlways);
// });
//
// function processResult(result) {
//     min(result.minAmount);
//     max(result.maxAmount);
//     abp.notify.success('Nastavení min./max. uloženo.');
//     showButton(false);
// }
//
// function doAlways() {
//     enableButton(true);
// }
//
// function showButton(active, btn) {
//     const $button = getButton(btn);
//     $button.toggleClass('active', active);
// }
//
// function enableButton(enabled, btn) {
//     const $button = getButton(btn);
//     $button.prop('disabled', !enabled);
// }
//
// function getButton(btn) {
//     return btn ? $(btn) : $(attributeSelector + ' button');
// }
//
// function getProductId(el) {
//     return $(el).closest(attributeSelector).attr(attributeSelector);
// }
//
// function min(val) {
//     return amount('[name="minAmount"]', val);
// }
//
// function max(val) {
//     return amount('[name="maxAmount"]', val);
// }
//
// function amount(inputSelector, val) {
//     const $input = $(attributeSelector + ' input' + inputSelector);
//     if (val) $input.val(val);
//     return $input.val();
// }
//
// // initializer
// export default function () {
//
// }


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/modules/min-max-setting.js
// module id = 1089
// module chunks = 1